import React from 'react';

export default function CTAPanel() {
  return (
    <section className="scroll-panel" style={{ background: 'var(--sumi)' }}>
      <div className="noise-overlay" />

      {/* Large background text */}
      <div
        className="absolute inset-0 flex items-center justify-center pointer-events-none select-none overflow-hidden"
        style={{ zIndex: 1 }}
      >
        <span
          className="font-fraunces"
          style={{
            fontSize: 'clamp(8rem, 20vw, 18rem)',
            fontWeight: 700,
            color: 'rgba(245,240,232,0.025)',
            letterSpacing: '-0.04em',
            lineHeight: 1,
            whiteSpace: 'nowrap',
          }}
        >
          ELITE CONSULTANCY
        </span>
      </div>

      <div className="w-full h-full flex flex-col md:flex-row items-stretch pt-16 pb-12 relative" style={{ zIndex: 2 }}>

        {/* LEFT: Final editorial statement */}
        <div
          className="flex-shrink-0 md:w-[50%] flex flex-col justify-center px-8 md:px-12 lg:px-16 py-8 md:py-10"
          style={{ borderRight: '1px solid rgba(245,240,232,0.1)' }}
        >
          <div className="panel-content">
            {/* Section label in light */}
            <div className="section-label mb-6" style={{ color: 'rgba(184,175,166,0.6)' }}>
              Final chapter — The Guide
            </div>

            <h2
              className="font-fraunces font-medium mb-8"
              style={{ fontSize: 'clamp(2rem, 4vw, 3.5rem)', color: 'var(--washi)', letterSpacing: '-0.02em', lineHeight: 1.05 }}
            >
              Everything this page<br />
              <span style={{ fontStyle: 'italic', color: 'rgba(245,240,232,0.6)' }}>just hinted at.</span>
            </h2>

            <hr style={{ border: 'none', borderTop: '1px solid rgba(245,240,232,0.15)', marginBottom: '28px' }} />

            {/* Stats row */}
            <div style={{ display: 'flex', gap: '32px', marginBottom: '32px' }}>
              {[
                { num: '47', label: 'pages' },
                { num: '23', label: 'countries' },
                { num: '0', label: 'fluff' },
              ].map(stat => (
                <div key={stat.label}>
                  <div
                    className="font-fraunces"
                    style={{ fontSize: '42px', fontWeight: 600, color: 'var(--washi)', letterSpacing: '-0.03em', lineHeight: 1 }}
                  >
                    {stat.num}
                  </div>
                  <div className="section-label" style={{ color: 'rgba(184,175,166,0.6)', marginTop: '4px' }}>
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            {/* CTA Button — vermillion */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', alignItems: 'flex-start' }}>
              <a
                href="#"
                className="font-dm-sans transition-all duration-200"
                style={{
                  background: 'var(--vermillion)',
                  color: 'var(--washi)',
                  padding: '16px 32px',
                  fontSize: '14px',
                  fontWeight: 600,
                  letterSpacing: '0.05em',
                  textTransform: 'uppercase',
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '12px',
                  border: '1px solid var(--vermillion)',
                }}
                onMouseEnter={e => {
                  (e.currentTarget as HTMLElement).style.background = 'transparent';
                  (e.currentTarget as HTMLElement).style.color = 'var(--vermillion)';
                }}
                onMouseLeave={e => {
                  (e.currentTarget as HTMLElement).style.background = 'var(--vermillion)';
                  (e.currentTarget as HTMLElement).style.color = 'var(--washi)';
                }}
              >
                Read the Full Guide
                <svg width="16" height="12" viewBox="0 0 16 12" fill="none">
                  <path d="M1 6H15M10 1L15 6L10 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </a>
              <span className="font-plex-mono" style={{ fontSize: '10px', letterSpacing: '0.15em', color: 'rgba(184,175,166,0.5)', textTransform: 'uppercase' }}>
                Free · No signup · PDF + web
              </span>
            </div>
          </div>
        </div>

        {/* RIGHT: What's inside */}
        <div className="flex-1 flex flex-col justify-center px-8 md:px-12 py-8 md:py-10">
          <div className="panel-content">
            <div className="section-label mb-6" style={{ color: 'rgba(184,175,166,0.6)' }}>
              What's inside
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '0px' }}>
              {[
                { ch: '01', title: 'Visa applications by country', detail: 'Approval rates, document checklists, embassy timelines' },
                { ch: '02', title: 'The real cost of living elite consultancy', detail: 'Monthly breakdowns, hidden costs, first-week expenses' },
                { ch: '03', title: 'Credit transfer negotiations', detail: 'Learning Agreement language, escalation scripts' },
                { ch: '04', title: 'Housing: the honest guide', detail: 'Deposits, scams, timing, university vs. private' },
                { ch: '05', title: 'Application timeline by program', detail: 'Country-specific Gantt charts, deadline calendars' },
                { ch: '06', title: 'IELTS & language requirements', detail: 'Real minimums, negotiation cases, alternatives' },
                { ch: '07', title: '23 student accounts', detail: 'Unedited, organized by country and outcome' },
              ].map((item, i) => (
                <div
                  key={item.ch}
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '16px',
                    padding: '14px 0',
                    borderBottom: '1px solid rgba(245,240,232,0.08)',
                  }}
                >
                  <span className="font-plex-mono" style={{ fontSize: '10px', color: 'rgba(184,175,166,0.4)', letterSpacing: '0.1em', flexShrink: 0, marginTop: '2px' }}>
                    {item.ch}
                  </span>
                  <div>
                    <div className="font-dm-sans" style={{ fontSize: '13px', fontWeight: 500, color: 'var(--washi)', marginBottom: '3px' }}>
                      {item.title}
                    </div>
                    <div className="section-label" style={{ color: 'rgba(184,175,166,0.5)', fontSize: '10px' }}>
                      {item.detail}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}